import { Field } from "formik";
import { FieldsGrid } from "../../../components/molecules";
import { FIELDS } from "../datamodels.constants";

const { TEXT } = FIELDS;

const ServiceFileUpload = ({ options, name, values }) => {
  return (
    <div className="flex flex-col text-sm font-medium m-2">
      {options.map((option) => (
        <div className="flex items-center mb-1" key={option}>
          <label>
            <Field
              type="radio"
              name={`${name}.type`}
              value={option}
              className="mr-2"
            />
            {option}
          </label>
        </div>
      ))}
      {values[name].type === "object-list" && (
        <FieldsGrid
          label="entry"
          name={`${name}.entries`}
          values={values[name].entries}
          fields={[{ name: "name", type: TEXT }]}
        />
      )}
    </div>
  );
};
export default ServiceFileUpload;
